"use client";

import { useEffect } from "react";

/**
 * Reloads the page when the browser restores it from the back/forward cache
 * (`pageshow` with `persisted`), so server-rendered account details can't
 * outlive a sign-out or an account switch on Back.
 *
 * Mount it only inside content that shows those details (the waitlisted hero).
 * A page that never renders it keeps instant Back, which is why this is not a
 * path in ProtectedBackGuard. A fresh load fires `pageshow` with
 * `persisted === false`, so it never loops.
 */
export function ReloadOnRestore() {
  useEffect(() => {
    const onPageShow = (e: PageTransitionEvent) => {
      if (e.persisted) window.location.reload();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  return null;
}
